import React, { useEffect, useState } from 'react'
import ReactHtmlParser, { processNodes, convertNodeToElement } from 'react-html-parser';
import InnerHTML from "dangerously-set-html-content";

function index(props: {html: string}) {
  const { html } = props;
  const [HTMLComponentVisible, setHTMLComponentVisible] = useState(false)
  
  useEffect(() => {
    setHTMLComponentVisible(false)
  }, [html])

  useEffect(() => {
    if(!HTMLComponentVisible) setHTMLComponentVisible(true)
  },[HTMLComponentVisible])
  
  return (
    <div className="report-parser">
      <div className="report-parser__container">
        {HTMLComponentVisible && html && <InnerHTML html={html} />}
      </div>
    </div>
  )
}

export default index